import * as Sentry from '@sentry/react';
import { useRouter } from '@tanstack/react-router';
import { DataTableRow } from 'cpool-components/general/DataTable';
import type { SchemaLoanRequestResolver_GetDuplicateInfoByLead } from 'cpool-tables/backend-resolvers';

import { TableColumnAdviserAssign } from '~/features/leadList/components/Table/columns/AdviserAssign';
import { ContactInfo } from '~/features/leadList/components/Table/columns/ContactInfo';
import { LeadInfo } from '~/features/leadList/components/Table/columns/LeadInfo';
import { StatusInfo } from '~/features/leadList/components/Table/columns/StatusInfo';

type Props = {
    lead: SchemaLoanRequestResolver_GetDuplicateInfoByLead[number];
    payload: Record<string, unknown>;
    originalLoanRequestId?: string;
};

export const DuplicatesRow: React.FC<Props> = ({ lead, originalLoanRequestId, payload }) => {
    const router = useRouter();

    const preload = async () => {
        try {
            await router.preloadRoute({
                params: { leadId: lead.id },
                to: '/leads/details/$leadId',
            });
        } catch (err) {
            Sentry.captureException(err);
        }
    };

    return (
        <DataTableRow
            data-testid="duplicates-row"
            payload={payload}
            className="cursor-pointer hover:bg-grey-table-hover duration-150"
            onClick={() => window.open(`/leads/details/${lead.id}`, '_blank')}
            onMouseEnter={preload}
        >
            <td>
                <ContactInfo lead={lead} showActionButtons={false} />
            </td>
            <td>
                <StatusInfo lead={lead} />
            </td>
            <td>
                <LeadInfo lead={lead} />
            </td>
            <td>
                <TableColumnAdviserAssign lead={lead} originalLoanRequestId={originalLoanRequestId} />
            </td>
        </DataTableRow>
    );
};
